module.exports = __webpack_public_path__ + "img/pr-2.dec74a78.png";